@import "~/styles/v1/_forms.scss";

.TextInput {
  @include form-input-base;

  // These are for height inconsistencies in Firefox
  height: 38px;
  &.TextInput_underline,
  &.TextInput_silent {
    height: 30px;
  }

  &.TextInput_S {
    height: 29px;
    &.TextInput_underline,
    &.TextInput_silent {
      height: 20px;
    }
  }

  &.TextInput_L,
  &.TextInput_XL {
    height: 49px;

    &.TextInput_underline,
    &.TextInput_silent {
      height: 38px;
    }
  }

  &[disabled] {
    border: 1px solid $system_white-darker;
    color: $system_eggplant-lightest;
    background: $system_white-lighter;
    opacity: 1;
  }
}

.overlay {
  display: flex;
  font-weight: 700;
  max-width: 90%;
  position: absolute;

  &:hover {
    color: $system_eggplant-darker;
    text-decoration: underline;
  }

  a {
    margin-right: $size-XS;
  }

  // NOTE: these match the font styles of the input
  &_M {
    font-size: 13px;
  }
  &_L {
    font-size: 16px;
    line-height: 1.75;
  }
  &_XL {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.45;
  }

  // NOTE: these should match the paddings/sizes of the corresponding input styles
  &_outline {
    left: $size-S + 1;
    top: $size-S + 1;

    &.overlay_S {
      top: $size-XS + 1;
    }
    &.overlay_XL {
      top: 8px;
    }

    &.overlay_right {
      left: unset;
      right: $size-S + 1;
    }
  }

  &_underline,
  &_silent {
    left: 0;
    top: $size-XS + 1;

    &.overlay_S {
      top: 1px;
    }
    &.overlay_L {
      top: $size-XS;
    }
    &.overlay_XL {
      top: 2px;
    }

    &.overlay_right {
      left: unset;
      right: 0;
    }
  }

  &_center {
    left: 50%;
    text-align: center;
    // We need this because we don't want the overlay being full-width
    transform: translate(-50%, 0);
  }
}

.container {
  position: relative;
  width: 100%;

  &.container_unfocused {
    color: transparent; // NOTE: this is safe as we only use the container with an overlay
  }

  &.container_disabled {
    .overlay {
      font-weight: normal; // Remove bold when disabled
    }
    input {
      color: transparent !important; // Hide input text when disabled, show only overlay
    }
  }

  :global(.text-input-overlay-link) {
    // fix for tailwind-root css reset (that makes color: inherit which is transparent in some cases)
    color: $system_eggplant-darker;
  }
}
